import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FuzzySearchActions } from '../actions';

function wrapperMapStateToProps(entity, field) {
    return function mapStateToProps(state) {
        let fuzzySearch = state.fuzzySearch.get(entity + '_' + field);
        return fuzzySearch
            ? fuzzySearch.toObject()
            : {
                  loading: false,
                  error: false,
                  show: false,
                  data: List(),
              };
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(FuzzySearchActions, dispatch),
    };
}

const propTypes = {
    onSelectItem: PropTypes.func.isRequired,
    processData: PropTypes.func.isRequired,

    actions: PropTypes.object.isRequired,
    entityDependence: PropTypes.string,
    entityDependenceId: PropTypes.string,
};

export default (entity, field) => {
    return (DecoratedComponent) => {
        let component = class extends Component {
            constructor(props) {
                super(props);
                this.state = {
                    isOnFocus: false,
                    innerText: props.searchText,
                };
            }

            componentWillUnmount = () => {
                const { actions, entityDependence, entityDependenceId } = this.props;
                actions.clearFuzzySearch(entity, field, entityDependence, entityDependenceId);
            };

            onFocus = () => {
                let { onFocus } = this.props;
                this._search('a')();
                this.setState({ isOnFocus: true });
                onFocus && onFocus();
            };

            onBlur = () => {
                let { onBlur } = this.props;
                this.setState({ isOnFocus: false });
                onBlur && onBlur(this.state.innerText);
            };

            _search = (value) => {
                return () => {
                    this._tmSearch = undefined;
                    const {
                        actions,
                        entityDependence,
                        entityDependenceId,
                        usersFromService,
                        newFuzzyMethod,
                        feature,
                    } = this.props;

                    if (newFuzzyMethod) {
                        actions.autoCompleteSearch(entity, field, value, feature);
                    } else {
                        actions.getFuzzySearch(
                            entity,
                            field,
                            value,
                            entityDependence,
                            entityDependenceId,
                            usersFromService,
                        );
                    }
                };
            };

            onUpdateInput = (value) => {
                let { onUpdateInput, keepText } = this.props;
                this._tmSearch && clearTimeout(this._tmSearch);
                if (value.length >= 1) {
                    this._tmSearch = setTimeout(this._search(value), 500);
                } else {
                    const { actions } = this.props;
                    actions.clearFuzzySearch(entity, field);
                }
                onUpdateInput && onUpdateInput(value);
                keepText && this.setState({ innerText: value });
            };

            _onNewRequest = (item, index) => {
                let { data, onSelectItem } = this.props;
                onSelectItem ? onSelectItem(item, index, data) : '';
            };

            render() {
                let { processData, data, showIconHint, keepText, searchText } = this.props;

                let { isOnFocus, innerText } = this.state;

                showIconHint = showIconHint === false ? false : true;

                let finalText = keepText && isOnFocus ? innerText : searchText;

                return (
                    <DecoratedComponent
                        {...this.props}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        searchText={finalText}
                        keepText={keepText}
                        openOnFocus={true}
                        arrowShow={false}
                        showIconHint={showIconHint}
                        ref={this.props.refCrud}
                        data={processData(data)}
                        onUpdateInput={this.onUpdateInput}
                        onNewRequest={this._onNewRequest}
                        isFuzzySearch={true}
                    />
                );
            }
        };

        component.propTypes = propTypes;

        return connect(wrapperMapStateToProps(entity, field), mapDispatchToProps, null, {
            forwardRef: true,
        })(component);
    };
};
